<template>
  <div class="flex flex-col gap-4 py-4">
    <TitlePrimary :title="isEdit ? $t('user.new.titleEdit') : role == 'superadmin' ? $t('user.new.title') : $t('user.new.titleAccount')" class="px-4 w-full" />

    <div class="user-form-layout px-4">
      <div class="user-client-column">

    <!-- Search account (similar to searchAccount in addComunidadesView).
         El personal de ADS no es de ninguna cuenta (ADSREC-0008). -->
   <div v-if="!isStaffTarget" class="w-full">
  <div class="relative w-full">
    <!-- Un cliente que pertenece a varias cuentas elige en cuál da de alta a la
         persona; con una sola se rellena sola. -->
    <SelectPrimary
      v-if="!canChooseAccount && !isEdit && ownAccounts.length > 1"
      :options="ownAccountOptions"
      :modelValue="formData.client_account_id ?? ''"
      @update:modelValue="selectOwnAccount"
      :label="$t('user.new.fields.admin')"
      :error="formErrors.assigned_to"
      class="w-full"
    />
    <inputPrimary
      v-else
      v-model="searchText"
      class="w-full"
      :label="canChooseAccount ? $t('user.new.fields.clientAccount') : $t('user.new.fields.admin')"
      type="text"
      :placeholder="canChooseAccount ? $t('user.new.placeholders.clientAccount') : $t('property.form.fields.searchPlaceholder')"
      @input="onSearchInput"
      :disabled="!canChooseAccount"
      :error="formErrors.assigned_to"
    />

    <div
      v-if="canChooseAccount && searchResults?.data?.length > 0"
      class="absolute left-0 right-0 top-full mt-1 border rounded p-2 bg-white z-20"
    >
      <ul>
        <li
          v-for="item in searchResults.data"
          :key="item.id"
          class="hover:bg-gray-100 cursor-pointer p-2 rounded"
          @click="selectSearchResult(item)"
        >
          <p class="font-medium text-[#385660]">{{ item.username || item.name }}</p>
        </li>
      </ul>
    </div>
  </div>
</div>
    <div class="user-client-fields">
      <div class="flex flex-col gap-4 w-full">
        <inputPrimary
          v-model="formData.name"
          class="w-full"
          :label="$t('user.new.fields.name')"
          type="text"
          :placeholder="$t('user.new.placeholders.name')"
          color="#2AB4D9"
          :error="formErrors.name"
        />
        <inputPrimary
          v-model="formData.lastname"
          class="w-full"
          :label="$t('user.new.fields.surname')"
          type="text"
          :placeholder="$t('user.new.placeholders.surname')"
          color="#2AB4D9"
          :error="formErrors.lastname"
        />
        <!-- DNI/CIF/NIE del personal de ADS: lo carga el superadministrador (ADSREC-0008). -->
        <inputPrimary
          v-if="canEditStaffProfile"
          v-model="formData.dniNie"
          class="w-full"
          :label="$t('admin.form.labels.identityDocument')"
          type="text"
          color="#2AB4D9"
          :error="formErrors.dni_nie"
        />
        <!-- Campos "nombre empresa" y "cp" comentados temporalmente
        <inputPrimary
          v-model="formData.companyName"
          class="w-full"
          :label="$t('user.fields.companyName')"
          type="text"
          :placeholder="$t('user.new.placeholders.companyName')"
          color="#2AB4D9"
          :error="formErrors.companyName"
        />
        <inputPrimary
          v-model="formData.cp"
          class="w-full"
          :label="$t('user.fields.cp')"
          type="text"
          :placeholder="$t('user.new.placeholders.cp')"
          color="#2AB4D9"
          :error="formErrors.cp"
        />
        -->
      </div>
      <div class="flex flex-col gap-4 w-full">
        <inputPrimary
          v-model="formData.email"
          class="w-full"
          :label="$t('user.new.fields.email')"
          type="email"
          :placeholder="$t('user.new.placeholders.email')"
          color="#2AB4D9"
          :error="formErrors.email"
          :disabled="!canEditEmail"
          :helpText="!canEditEmail ? $t('user.new.hints.emailLocked') : ''"
        />
        <inputPrimary
          :modelValue="formData.phone"
          @update:modelValue="handlePhoneUpdate"
          class="w-full"
          :label="$t('user.new.fields.phone')"
          type="tel"
          :placeholder="$t('user.new.placeholders.phone')"
          color="#2AB4D9"
          :error="formErrors.phone"
        />
        <!-- Perfil del personal de ADS (ADSREC-0008); nadie cambia el suyo. -->
        <SelectPrimary
          v-if="canEditStaffProfile"
          v-model="formData.adsRole"
          name="adsRole"
          :options="adsRoleOptions"
          :placeholder="$t('user.new.placeholders.role')"
          :label="$t('admin.form.labels.accountType')"
          :disabled="isEditingSelf"
          :error="formErrors.role"
          class="w-full"
        />
        <!-- Campo "rol" comentado temporalmente
        <div class="flex flex-col gap-7">
          <label class="text-[#2AB4D9] font-medium text-center">{{ $t('user.new.fields.role') }}</label>
          <select
            v-model="formData.role"
            class="w-full p-2 border border-[#2AB4D9] rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2AB4D9] text-center"
          >
            <option value="">{{ $t('user.new.placeholders.role') }}</option>
            <option value="horizontal">{{ $t('user.new.roles.horizontal') }}</option>
            <option value="vertical">{{ $t('user.new.roles.vertical') }}</option>
            <option value="both">{{ $t('user.new.roles.ambos') }}</option>
          </select>
          <p v-if="formErrors.role" class="text-red-500 text-sm mt-1 text-center">{{ formErrors.role }}</p>
        </div>
        -->
        <!-- Bloque "comercial asignado" y "nombre de contacto" comentado temporalmente
          <template v-if="role === 'superadmin'">
            <div class="w-full" style="margin: 8px 0;">
              <label class="text-[#385660] font-medium block mb-2" style="font-size: 16px;">
                {{ $t('user.fields.assignedCommercial') }}
              </label>
              <div class="flex items-center border border-[#3A5762] rounded-lg px-3 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]">
                <input
                  type="text"
                  class="flex-1 py-2 h-10 text-sm border-none outline-none text-[#7CADB9] bg-transparent"
                  style="font-size: 14px;"
                  :value="selectedCommercial?.name || ''"
                  :placeholder="$t('user.new.placeholders.assignedCommercial')"
                  readonly
                  @click="openCommercialSearchModal"
                />
                <button
                  @click="openCommercialSearchModal"
                  class="p-1 hover:bg-gray-100 rounded transition-colors flex-shrink-0"
                  :title="$t('user.actions.editCommercial')"
                >
                  <svg class="w-4 h-4 text-[#385660] hover:text-[#2AB4D9]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                  </svg>
                </button>
                <p v-if="formErrors.father || formErrors.commercial" class="text-red-500 text-sm mt-1">{{ formErrors.father || formErrors.commercial }}</p>
              </div>
            </div>
            <inputPrimary
              v-model="formData.contactName"
              class="w-full"
              :label="$t('user.fields.contactName')"
              type="text"
              :placeholder="$t('user.new.placeholders.contactName')"
              color="#2AB4D9"
              :error="formErrors.contactName"
              />
          </template>
        -->
      </div>
    </div>
      </div>
      <div class="user-options-column">
      <div class="user-preferences">
        <div class="flex flex-col gap-2">
          <label class="text-[#385660] font-medium text-start">{{ $t('user.new.fields.notifications') }}</label>
          <div class="flex gap-2 sm:gap-4 justify-center flex-wrap">
            <button
              @click="formData.notifications = true"
              :class="[
                'px-6 sm:px-8 py-2 rounded-lg transition-colors w-20 sm:w-24 text-center text-sm sm:text-base',
                formData.notifications ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]'
              ]"
            >
              {{ $t('user.new.buttons.yes') }}
            </button>
            <button
              @click="formData.notifications = false"
              :class="[
                'px-6 sm:px-8 py-2 rounded-lg transition-colors w-20 sm:w-24 text-center text-sm sm:text-base',
                !formData.notifications ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]'
              ]"
            >
              {{ $t('user.new.buttons.no') }}
            </button>
          </div>
        </div>
        <!-- Ver todas las incidencias (ADS-0122): lo fija ADS o el principal de la cuenta; nadie el suyo -->
        <div class="flex flex-col gap-2" data-testid="sees-all-requests">
          <label class="text-[#385660] font-medium text-start">{{ $t('user.new.fields.seesAllRequests') }}</label>
          <div class="flex gap-2 sm:gap-4 justify-center flex-wrap">
            <button
              type="button"
              :disabled="isEditingSelf"
              @click="formData.seesAllRequests = true"
              :class="[
                'px-6 sm:px-8 py-2 rounded-lg transition-colors w-20 sm:w-24 text-center text-sm sm:text-base',
                formData.seesAllRequests ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]',
                isEditingSelf ? 'opacity-50 cursor-not-allowed' : ''
              ]"
            >
              {{ $t('user.new.buttons.yes') }}
            </button>
            <button
              type="button"
              :disabled="isEditingSelf"
              @click="formData.seesAllRequests = false"
              :class="[
                'px-6 sm:px-8 py-2 rounded-lg transition-colors w-20 sm:w-24 text-center text-sm sm:text-base',
                !formData.seesAllRequests ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]',
                isEditingSelf ? 'opacity-50 cursor-not-allowed' : ''
              ]"
            >
              {{ $t('user.new.buttons.no') }}
            </button>
          </div>
          <p class="text-xs text-gray-500 text-start">{{ isEditingSelf ? $t('user.new.hints.seesAllRequestsSelf') : $t('user.new.hints.seesAllRequests') }}</p>
        </div>
      </div>
      <div class="flex flex-col gap-4 w-full user-status-row">
        <div class="flex flex-col gap-2">
          <label class="text-[#385660] font-medium text-start">{{ $t('user.new.fields.status') }}</label>
          <div v-if="!isEdit" class="flex flex-wrap gap-2 sm:gap-4">
            <button
              @click="formData.status = 'active'"
              :class="[
                'min-h-11 min-w-36 px-4 py-2 rounded-lg transition-colors text-center text-sm sm:text-base',
                formData.status === 'active' ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]'
              ]"
            >
              {{ $t('user.new.buttons.active') }}
            </button>
            <button
              @click="formData.status = 'inactive'"
              :class="[
                'min-h-11 min-w-36 px-4 py-2 rounded-lg transition-colors text-center text-sm sm:text-base',
                formData.status === 'inactive' ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]'
              ]"
            >
              {{ $t('user.new.buttons.inactive') }}
            </button>
          </div>
          <p v-else class="text-center text-sm text-gray-500">{{ $t('user.statusAction.editHint') }}</p>
        </div>
        <div class="flex flex-col gap-4 pb-4">
          <!-- Campo "administrador" comentado temporalmente
          <label class="text-[#385660] font-medium text-center">{{ $t('user.new.fields.admin') }}</label>
          <div class="flex gap-2 sm:gap-4 justify-center flex-wrap">
            <button
              @click="formData.is_admin = true"
              :class="[
                'px-6 sm:px-8 py-2 rounded-lg transition-colors w-20 sm:w-24 text-center text-sm sm:text-base',
                formData.is_admin ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]'
              ]"
            >
              {{ $t('user.new.buttons.yes') }}
            </button>
            <button
              @click="formData.is_admin = false"
              :class="[
                'px-6 sm:px-8 py-2 rounded-lg transition-colors w-20 sm:w-24 text-center text-sm sm:text-base',
                !formData.is_admin ? 'bg-[#2AB4D9] text-white' : 'bg-white text-[#2AB4D9] border border-[#2AB4D9]'
              ]"
            >
              {{ $t('user.new.buttons.no') }}
            </button>
          </div>
          -->
        </div>
      </div>
    <div v-if="!isEdit && adsUser && (!creationFinished || accessReady)" class="w-full">
      <InitialCredentials
        :password="accessReady ? savedCredentials.password : formData.password"
        @update:password="formData.password = $event"
        v-model:confirmation="formData.password_confirmation"
        :email="accessReady ? savedCredentials.email : formData.email"
        :saved="accessReady"
        :password-error="formErrors.password"
        :confirmation-error="formErrors.password_confirmation"
      />
    </div>

    <div class="user-form-footer">
        <div v-if="accessReady" class="text-sm text-[#385660]">
          {{ $t('accessCredentials.ready') }}
          <button type="button" @click="router.push('/user')" class="mt-3 min-h-11 w-full rounded-lg border border-[#92b0bd] bg-white px-5 py-2.5 font-semibold hover:bg-[#eaf5f9] focus-visible:outline-3 focus-visible:outline-[#25b0d7] sm:w-auto">{{ $t('accessCredentials.done') }}</button>
        </div>
        <div v-else-if="creationFinished" class="text-sm text-red-600">
          {{ $t('accessCredentials.notReady') }}
          <button type="button" @click="router.push('/user')" class="mt-3 min-h-11 w-full rounded-lg border border-[#92b0bd] bg-white px-5 py-2.5 font-semibold text-[#385660] hover:bg-[#eaf5f9] focus-visible:outline-3 focus-visible:outline-[#25b0d7] sm:w-auto">{{ $t('accessCredentials.done') }}</button>
        </div>
        <ButtonWhite
          v-else
          @click="submitForm"
          :title="$t('user.new.buttons.save')"
          class="min-h-11 w-full justify-center sm:max-w-[240px]"
          bgColor="bg-[#2AB4D9]"
          textColor="text-white"
          hoverBgColor="bg-[#2AB4D9]"
        />
    </div>
      </div>
    </div>

    <!-- Commercial Search Modal -->
    <div v-if="showCommercialSearchModal" class="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div class="bg-white rounded-xl shadow-lg w-full max-w-md max-h-[90vh] sm:max-h-[80vh] flex flex-col">
        <!-- Header -->
        <div class="flex items-center justify-between p-4 sm:p-6 border-b">
          <h3 class="text-base sm:text-lg font-semibold text-[#385660]">{{ $t('user.modalCommercialSearch.title') }}</h3>
          <button @click="closeCommercialSearchModal" class="text-gray-400 hover:text-gray-600 transition-colors">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div>

        <!-- Search Input -->
        <div class="p-4 sm:p-6 border-b">
          <div class="relative">
            <input
              v-model="commercialSearchQuery"
              @input="searchCommercials"
              type="text"
              :placeholder="$t('user.modalCommercialSearch.searchPlaceholder')"
              class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#2AB4D9] focus:border-transparent"
            />
            <div v-if="isSearchingCommercials" class="absolute right-3 top-1/2 transform -translate-y-1/2">
              <div class="animate-spin rounded-full h-5 w-5 border-b-2 border-[#2AB4D9]"></div>
            </div>
          </div>
        </div>

        <!-- Commercial List -->
        <div class="flex-1 overflow-y-auto p-4 sm:p-6">
          <div v-if="isSearchingCommercials && !searchedCommercials.length" class="text-center py-8 text-gray-500">
            {{ $t('user.modalCommercialSearch.searching') }}
          </div>
          <div v-else-if="!isSearchingCommercials && !searchedCommercials.length && commercialSearchQuery"
            class="text-center py-8 text-gray-500">
            {{ $t('user.modalCommercialSearch.noResults') }}
          </div>
          <div v-else-if="!commercialSearchQuery" class="text-center py-8 text-gray-500">
            {{ $t('user.modalCommercialSearch.startTyping') }}
          </div>
          <div v-else class="space-y-2">
            <button
              v-for="commercial in searchedCommercials"
              :key="commercial.id"
              @click="selectCommercial(commercial)"
              class="w-full text-left p-3 rounded-lg border border-gray-200 hover:bg-gray-50 hover:border-[#2AB4D9] transition-colors"
            >
              <div class="font-medium text-[#385660]">{{ commercial.name }}</div>
              <div v-if="commercial.email" class="text-sm text-gray-500">{{ commercial.email }}</div>
            </button>
          </div>
        </div>

        <!-- Footer -->
        <div class="p-4 sm:p-6 border-t flex justify-end space-x-3">
          <button
            @click="closeCommercialSearchModal"
            class="px-4 py-2 text-sm sm:text-base text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            {{ $t('user.modalCommercialSearch.cancel') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import inputPrimary from '@/components/inputs/input-primary.vue';
import SelectPrimary from '@/components/select/SelectPrimary.vue';
import TitlePrimary from '@/components/title/title-primary.vue';
import ButtonWhite from '@/components/button/ButtonWhite.vue';
import axios from 'axios';
import { useI18n } from 'vue-i18n';
import { hasAnyRole, isAdsUser, isBackOffice } from '@/services/userRoles';
import InitialCredentials from '@/components/access/InitialCredentials.vue';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const role = ref(localStorage.getItem('role'));
const isSuperadmin = hasAnyRole(['superadmin']);
const backOffice = isBackOffice();
const adsUser = isAdsUser();

// Perfiles del personal de ADS, con los nombres del alta de Usuarios ADS.
const ADS_ROLES = ['comercial', 'admin', 'superadmin'];
const adsRoleOptions = ADS_ROLES.map((value) => ({ value, label: t(`common.requestTypes.${value}`) }));
// Un gestor del legacy con perfil de cliente todavía no tiene perfil interno.
const currentAdsRole = (data) => ADS_ROLES.find((adsRole) =>
  (data?.roles || []).some((userRole) => (userRole?.name ?? userRole) === adsRole)) || '';

// Edit mode detection
const userId = route.query.id;
const isEdit = !!userId;
const canEditEmail = !isEdit || adsUser;

// State for edit
const loading = ref(false);
const error = ref(null);
const originalData = ref(null);
const accessReady = ref(false);
const creationFinished = ref(false);
const savedCredentials = ref(null);

// Commercial search modal variables
const showCommercialSearchModal = ref(false);
const commercialSearchQuery = ref('');
const searchedCommercials = ref([]);
const isSearchingCommercials = ref(false);
const searchTimeout = ref(null);
const selectedCommercial = ref(null);

// Account search (similar to addComunidadesView)
const searchText = ref('');
const searchResults = ref(null);
const isSelectingSearchResult = ref(false);
const accountSearchTimeout = ref(null);
const selectedAccount = ref(null);

const formData = ref({
  name: '',
  lastname: '',
  email: '',
  password: '',
  password_confirmation: '',
  phone: '',
  notifications: true,
  // Ver todas las incidencias (ADS-0122): por defecto No
  seesAllRequests: false,
  // Cuenta cliente a la que pertenece la persona; el selector de ADS trabaja
  // con cuentas, no con personas (ADS-0119).
  client_account_id: null,
  // role: [], // comentado temporalmente
  status: 'active',
  // is_admin: false, // comentado temporalmente
  // companyName: '', // comentado temporalmente
  // cp: '', // comentado temporalmente
  // father: null, // comentado temporalmente
  // commercial: '', // comentado temporalmente
  // contactName: '' // comentado temporalmente
  assigned_to: null,
  // DNI/CIF/NIE y perfil del personal de ADS (ADSREC-0008)
  dniNie: '',
  adsRole: ''
});

const phoneHasInvalidCharacters = ref(false);

const normalizePhone = (value) => String(value || '').replace(/[^\d]/g, '');

const handlePhoneUpdate = (value) => {
  phoneHasInvalidCharacters.value = /[^\d]/.test(String(value || ''));
  formData.value.phone = normalizePhone(value);

  if (!phoneHasInvalidCharacters.value) {
    formErrors.value.phone = '';
  }
};

// Fetch user data when editing and populate form
const fetchUserData = async () => {
  const idToFetch = route.query.id || userId;
  if (!idToFetch) return;
  loading.value = true;
  try {
    const response = await axios.get(`${import.meta.env.VITE_API_URL}/user/get/${idToFetch}`, {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (response.data?.value) {
      const data = response.data.value;
      originalData.value = data;

      formData.value.name = data.name || '';
      formData.value.lastname = data.surname || '';
      formData.value.email = data.email || '';
      formData.value.phone = data.mobile || data.telephone || '';
      formData.value.notifications = Boolean(data.has_notifications);
      formData.value.seesAllRequests = Boolean(data.sees_all_requests);
      formData.value.status = data.status || 'active';
      // assigned_to used in create; try common keys
      formData.value.assigned_to = data.assigned_to ?? data.assigned_to_id ?? null;
      formData.value.dniNie = data.dni_nie || '';
      formData.value.adsRole = currentAdsRole(data);
      // «Empresa» es el nombre de la cuenta cliente de la persona (`account`),
      // no su `username`, que en las cuentas migradas es el correo.
      searchText.value = data.account || data.username || data.name || '';
    }
  } catch (err) {
    console.error('Error fetching user for edit:', err);
    toast.error(t('user.new.messages.error') || 'Error al cargar datos');
    error.value = t('user.new.messages.error') || 'Error al cargar datos';
  } finally {
    loading.value = false;
  }
};

// Pre-fill admin search field when navigating from AdminDetail with admin_id
const prefillAdmin = async (adminId) => {
  try {
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/user/get/${adminId}`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    const data = response.data?.value || response.data;
    if (data) {
      formData.value.assigned_to = adminId;
      searchText.value = data.username || data.name || '';
    }
  } catch (err) {
    console.error('Error pre-filling admin:', err);
  }
};

// React to route query changes (component reuse) and initial mount
onMounted(() => {
  if (route.query.id) fetchUserData();
  if (route.query.admin_id) prefillAdmin(route.query.admin_id);
});

watch(
  () => route.query.id,
  (newId, oldId) => {
    if (newId && newId !== oldId) {
      fetchUserData();
    }
  }
);

// Determine changed fields for PATCH/PUT
const getChangedFields = () => {
  if (!originalData.value) return null;
  const changed = {};
  const orig = originalData.value;
  if ((orig.name || '') !== (formData.value.name || '')) changed.name = formData.value.name;
  if ((orig.surname || '') !== (formData.value.lastname || '')) changed.surname = formData.value.lastname;
  if (canEditEmail && (orig.email || '') !== (formData.value.email || '')) changed.email = formData.value.email;
  const origPhone = orig.mobile || orig.telephone || '';
  if (origPhone !== (formData.value.phone || '')) changed.mobile = normalizePhone(formData.value.phone);
  if (Boolean(orig.has_notifications) !== Boolean(formData.value.notifications)) changed.has_notifications = formData.value.notifications;
  if (!isEditingSelf.value && Boolean(orig.sees_all_requests) !== Boolean(formData.value.seesAllRequests)) changed.sees_all_requests = formData.value.seesAllRequests;
  if ((orig.assigned_to ?? null) !== (formData.value.assigned_to ?? null)) changed.assigned_to = formData.value.assigned_to;
  if (canEditStaffProfile.value) {
    const dniNie = String(formData.value.dniNie || '').trim();
    if ((orig.dni_nie || '') !== dniNie) changed.dni_nie = dniNie || null;
    if (!isEditingSelf.value && formData.value.adsRole && formData.value.adsRole !== currentAdsRole(orig)) {
      changed.role = formData.value.adsRole;
    }
  }

  return Object.keys(changed).length ? changed : null;
};

// Validation errors for the form
const formErrors = ref({
  name: '',
  lastname: '',
  phone: '',
  email: '',
  password: '',
  password_confirmation: '',
  assigned_to: '',
  dni_nie: '',
  role: '',
  // companyName: '', // comentado temporalmente
  // cp: '', // comentado temporalmente
  // contactName: '', // comentado temporalmente
  // commercial: '', // comentado temporalmente
  // father: '', // comentado temporalmente
  status: ''
});

// Commercial search modal functions
// const openCommercialSearchModal = () => {
//   showCommercialSearchModal.value = true;
//   commercialSearchQuery.value = '';
//   searchedCommercials.value = [];
//   selectedCommercial.value = null;
// };

const closeCommercialSearchModal = () => {
  showCommercialSearchModal.value = false;
  commercialSearchQuery.value = '';
  searchedCommercials.value = [];
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value);
    searchTimeout.value = null;
  }
};

const searchCommercials = () => {
  if (searchTimeout.value) {
    clearTimeout(searchTimeout.value);
  }

  if (commercialSearchQuery.value.trim() === '') {
    searchedCommercials.value = [];
    return;
  }

  searchTimeout.value = setTimeout(async () => {
    isSearchingCommercials.value = true;
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_URL}/user/search`,
        {
          params: {
            query: commercialSearchQuery.value,
            // role_filter: 'both_admins'
          },
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      // Adaptación para estructura { value: { data: [...] } }
      if (response.data && response.data.value && response.data.value.data) {
        searchedCommercials.value = response.data.value.data;
      } else if (response.data && response.data.data) {
        searchedCommercials.value = response.data.data;
      } else {
        searchedCommercials.value = [];
      }
    } catch (error) {
      console.error('Error searching commercials:', error);
      toast.error(t('user.modalCommercialSearch.errorSearch'));
    } finally {
      isSearchingCommercials.value = false;
    }
  }, 300);
};

const selectCommercial = (commercial) => {
  selectedCommercial.value = commercial;
  // formData.value.father = commercial.id; // comentado temporalmente
  // formData.value.commercial = commercial.name; // comentado temporalmente
  closeCommercialSearchModal();
  toast.success(t('user.modalCommercialSearch.successSelect'));
};

// Account search functions
const onSearchInput = () => {
  if (accountSearchTimeout.value) clearTimeout(accountSearchTimeout.value);

  if (searchText.value.trim() === '') {
    searchResults.value = null;
    return;
  }

  accountSearchTimeout.value = setTimeout(async () => {
    await performSearch(searchText.value);
  }, 300);
};

const userLocalId = localStorage.getItem('id');
// Nadie se cambia a sí mismo "Ver todas las incidencias"; la API también lo rechaza.
const isEditingSelf = computed(() => isEdit && String(userId) === String(userLocalId));

// Ficha de alguien de «Usuarios ADS» (ADSREC-0008). Su DNI/CIF/NIE y su perfil
// los cambia solo el superadministrador: Back Office lo da de alta, pero no lo
// modifica, y nadie se cambia su propio perfil.
const isStaffTarget = computed(() => isEdit && originalData.value?.is_ads_staff === true);
const canEditStaffProfile = computed(() => isStaffTarget.value && isSuperadmin);
const isLoadingSupervisor = ref(false);

// El responsable y Back Office eligen la cuenta cliente de la persona que dan
// de alta (ADS-0119); un cliente solo puede sumar gente a la suya, que se
// rellena sola.
const canChooseAccount = isSuperadmin || backOffice;

onMounted(async () => {
  // Solo en el alta: al modificar, la cuenta es la que ya tiene la persona y la
  // trae su propia ficha; no se elige ni se cambia desde aquí.
  if (!canChooseAccount && !isEdit) {
    await loadSupervisorChain(userLocalId);
  }
});

// Cuentas cliente del propio usuario. «Empresa» es el nombre de la cuenta,
// no el `username` de la persona (que es su correo). Con varias cuentas el
// back no puede deducir en cuál dar de alta, así que se elige aquí.
const ownAccounts = ref([]);
const ownAccountOptions = computed(() => ownAccounts.value.map((account) => ({
  value: account.id,
  label: account.type_label ? `${account.name} · ${account.type_label}` : account.name,
})));

const selectOwnAccount = (value) => {
  const account = ownAccounts.value.find((item) => String(item.id) === String(value)) || null;
  formData.value.client_account_id = account?.id ?? null;
  searchText.value = account?.name || '';
  formErrors.value.assigned_to = '';
};

const loadSupervisorChain = async (currentUserId) => {
  isLoadingSupervisor.value = true;
  try {
    formData.value.assigned_to = userLocalId;

    const accountsResponse = await axios.get(`${import.meta.env.VITE_API_URL}/client-account/mine`, {
      headers: { 'Accept': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    });
    ownAccounts.value = Array.isArray(accountsResponse.data?.value) ? accountsResponse.data.value : [];

    if (ownAccounts.value.length === 1) {
      selectOwnAccount(ownAccounts.value[0].id);
      return;
    }
    if (ownAccounts.value.length > 1) {
      return;
    }

    // Persona sin cuenta cliente: se mantiene el dato de su ficha.
    const step1 = await axios.get(
      `${import.meta.env.VITE_API_URL}/user/get/${currentUserId}`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      }
    );
    const currentUserData = step1.data.value || step1.data;
    searchText.value = currentUserData.account || currentUserData.username || '';

  } catch (error) {
    console.error('Error completo:', error);
    console.error('Error response:', error.response);
    searchText.value = 'Error al cargar';
  } finally {
    isLoadingSupervisor.value = false;
  }
};

const performSearch = async (query) => {
  if (!query || query.length < 2) {
    searchResults.value = null;
    return;
  }

  try {
    // Buscador de cuentas cliente, disponible para todo el personal de ADS; el
    // anterior era exclusivo del responsable y Back Office no veía resultados.
    const response = await axios.get(
      `${import.meta.env.VITE_API_URL}/client-account/search`,
      {
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        params: { query, per_page: 10 }
      }
    );

    searchResults.value = response.data.value?.data?.length ? { data: response.data.value.data } : null;
  } catch (error) {
    console.error('Error en la búsqueda de cuentas:', error);
    searchResults.value = null;
  }
};

const selectSearchResult = (result) => {
  isSelectingSearchResult.value = true;
  selectedAccount.value = result;
  // `result.id` es el id de la cuenta cliente: viaja como tal. Enviarlo en
  // `assigned_to`, que es una clave ajena a `users`, hacía fallar el alta.
  formData.value.client_account_id = result.id;
  // formData.value.companyName = result.username || result.name || formData.value.companyName; // comentado temporalmente
  searchText.value = result.username || result.name || '';
  searchResults.value = null;
};

// Client-side validation similar to addLightView
function validateForm() {
  // clear previous
  Object.keys(formErrors.value).forEach((k) => (formErrors.value[k] = ''));
  let valid = true;

  // Hay que decir de quién es la persona: el personal de ADS elige la cuenta
  // cliente en el buscador (ADS-0119) y el cliente cuelga de su propia ficha.
  if (canChooseAccount) {
    if (!isEdit && !formData.value.client_account_id) {
      formErrors.value.assigned_to = t('user.new.messages.account_required');
      valid = false;
    }
  } else if (!isEdit && ownAccounts.value.length > 1 && !formData.value.client_account_id) {
    // Cliente con varias cuentas: tiene que decir en cuál da de alta.
    formErrors.value.assigned_to = t('user.new.messages.account_required');
    valid = false;
  } else if (!isEdit && !formData.value.assigned_to) {
    formErrors.value.assigned_to = t('form.errors.required');
    valid = false;
  }

  // email: required, basic format. Al modificar, una ficha que nunca tuvo correo
  // (las cuentas «API …» del personal, ADSREC-0008) se guarda sin él.
  const email = String(formData.value.email || '').trim();
  const emailRequired = !isEdit || Boolean(originalData.value?.email);
  if (!email) {
    if (emailRequired) {
      formErrors.value.email = t('form.errors.required');
      valid = false;
    }
  } else if (!/^\S+@\S+\.\S+$/.test(email)) {
    formErrors.value.email = t('form.validation.email_invalid') || 'Email no válido';
    valid = false;
  }

  if (!isEdit && adsUser) {
    if (formData.value.password.length < 8) {
      formErrors.value.password = t('accessCredentials.minLength');
      valid = false;
    }
    if (formData.value.password !== formData.value.password_confirmation) {
      formErrors.value.password_confirmation = t('accessCredentials.mismatch');
      valid = false;
    }
  }

  /* Validación de rol comentada temporalmente
  const allowedRoles = ['both', 'horizontal', 'vertical', 'superadmin'];
  if (!formData.value.role || String(formData.value.role).trim() === '') {
    formErrors.value.role = t('form.errors.required');
    valid = false;
  } else if (!allowedRoles.includes(String(formData.value.role))) {
    formErrors.value.role = t('form.validation.role_invalid') || 'Rol inválido';
    valid = false;
  }
  */

  // optional fields validations (lengths)
  if (formData.value.name && String(formData.value.name).length > 255) {
    formErrors.value.name = t('form.validation.name_max') || 'Nombre demasiado largo';
    valid = false;
  }
  if (formData.value.lastname && String(formData.value.lastname).length > 255) {
    formErrors.value.lastname = t('form.validation.lastname_max') || 'Apellido demasiado largo';
    valid = false;
  }

  if (phoneHasInvalidCharacters.value || (formData.value.phone && !/^\d{8,15}$/.test(String(formData.value.phone)))) {
    formErrors.value.phone = t('form.validation.phone_invalid') || 'Teléfono no válido';
    valid = false;
  }

  // Validaciones de "cp" y "companyName" comentadas temporalmente
  /*
  if (formData.value.cp && String(formData.value.cp).length > 20) {
    formErrors.value.cp = t('form.validation.cp_max') || 'Código postal no válido';
    valid = false;
  }

  if (formData.value.companyName && String(formData.value.companyName).length > 255) {
    formErrors.value.companyName = t('form.validation.company_max') || 'Nombre de empresa demasiado largo';
    valid = false;
  }
  */

  return valid;
}

/**
 * ¿La API rechazó el alta porque ese correo ya existe? El mensaje de
 * `unique:users` llega en inglés y depende del idioma de la API, así que se
 * reconoce por el campo y no por el texto exacto (ADS-0119).
 */
const isDuplicateEmailError = (field, message) =>
  field === 'email' && /already been taken|ya (está|ha sido)/i.test(String(message || ''));
// Lo mismo con el DNI/CIF/NIE del personal de ADS (ADSREC-0008).
const isDuplicateDocumentError = (field, message) =>
  field === 'dni_nie' && /already been taken|ya (está|ha sido)/i.test(String(message || ''));

const submitForm = async () => {
  if (creationFinished.value) return;
  try {
    // Clear previous errors
    Object.keys(formErrors.value).forEach((k) => (formErrors.value[k] = ''));

    // client-side validation
    if (!validateForm()) {
      // show toast and stop submit; field-level errors are shown under inputs
      toast.error(t('user.new.messages.required_fields'));
      return;
    }

    // If editing, send PUT with changed fields only
    if (isEdit) {
      const changes = getChangedFields();
      if (!changes) {
        toast.info(t('user.new.messages.no_changes') || 'No hay cambios para guardar');
        return;
      }

      await axios.put(`${import.meta.env.VITE_API_URL}/user/update/${userId}`, changes, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      toast.success(t('user.new.messages.success_update') || 'Usuario actualizado correctamente');
      // El personal de ADS vuelve a su ficha, donde se ven su documento y su perfil.
      setTimeout(() => router.push(isStaffTarget.value ? `/user-detail/${userId}` : '/user'), 1200);
      return;
    }

    // Creation flow (unchanged)
    const userData = {
      name: formData.value.name,
      surname: formData.value.lastname,
      mobile: normalizePhone(formData.value.phone),
      has_notifications: formData.value.notifications,
      sees_all_requests: formData.value.seesAllRequests,
      email: formData.value.email,
      ...(adsUser ? { password: formData.value.password, password_confirmation: formData.value.password_confirmation } : {}),
      status: formData.value.status,
      is_primary: false,
    };

    if (formData.value.client_account_id) {
      userData.client_account_id = formData.value.client_account_id;
    } else if (formData.value.assigned_to) {
      // Un cliente suma gente a su propia cuenta: cuelga de su persona.
      userData.assigned_to = formData.value.assigned_to;
    }

    const response = await axios.post(`${import.meta.env.VITE_API_URL}/admin/create`, userData, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    toast.success(t('user.new.messages.success'));
    if (adsUser) {
      creationFinished.value = true;
      accessReady.value = response.data?.access_ready === true;
      if (accessReady.value) {
        savedCredentials.value = { email: userData.email, password: userData.password };
      } else {
        toast.error(t('accessCredentials.notReady'));
      }
    } else {
      setTimeout(() => router.push('/user'), 2000);
    }
  } catch (error) {
    // Map backend validation errors to formErrors
    const respData = error.response && error.response.data ? error.response.data : null;
    if (respData) {
      if (respData.errors && typeof respData.errors === 'object') {
        const mapping = {
          name: 'name',
          surname: 'lastname',
          mobile: 'phone',
          has_notifications: 'notifications',
          email: 'email',
          dni_nie: 'dni_nie',
          iban: 'iban',
          role: 'role',
          username: 'username',
          status: 'status',
          cif: 'cif',
          company_name: 'companyName',
          contact_name: 'contactName',
          password_sent: 'password_sent',
          contract_sent: 'contract_sent',
          address: 'address',
          observations: 'observations',
          postal_code: 'cp',
          city: 'city',
          state: 'state',
          maintenance: 'maintenance',
          commercial: 'commercial',
          father: 'father'
        };

        Object.keys(respData.errors).forEach((key) => {
          const msg = Array.isArray(respData.errors[key]) ? respData.errors[key][0] : respData.errors[key];
          const frontKey = mapping[key] || key;
          // Only set known keys in formErrors (avoid unexpected keys)
          if (frontKey in formErrors.value) {
            formErrors.value[frontKey] = isDuplicateEmailError(key, msg)
              ? t('user.new.messages.email_taken')
              : isDuplicateDocumentError(key, msg) ? t('user.new.messages.document_taken') : msg;
          }
        });
      } else if (respData.message && typeof respData.message === 'string') {
        const apiMsg = respData.message;
        if (isDuplicateEmailError('email', apiMsg)) {
          formErrors.value.email = t('user.new.messages.email_taken');
        } else if (apiMsg.toLowerCase().includes('email')) {
          formErrors.value.email = apiMsg;
        } else {
          toast.error(apiMsg);
        }
      }
    }

    // Show a toast with first available error or generic message
    const firstError = Object.values(formErrors.value).find((v) => v && v.length);
    toast.error(firstError || error.message || t('user.new.messages.error'));
  }
};
</script>

<style scoped>
.user-form-layout {
  display: flex;
  align-items: flex-start;
  gap: 32px;
  width: 100%;
}

.user-client-column,
.user-options-column {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  gap: 24px;
  min-width: 0;
}

.user-client-fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.user-preferences {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.user-preferences > div > div {
  justify-content: flex-start;
}

.user-preferences button {
  min-height: 44px;
}

.user-status-row {
  width: 100%;
}

.user-form-footer {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 24px;
}

@media (max-width: 1100px) {
  .user-form-layout {
    flex-direction: column;
  }

  .user-client-column,
  .user-options-column {
    width: 100%;
  }
}
</style>
